import {
  axiosRequestDELETE,
  axiosRequestGET,
  axiosRequestPOST,
  axiosRequestPUT,
} from './serviceConfig';
import { EMPTY_ID } from '../constants';

const elementStatusFilterType = 'element-status';

export const getElementsStatusV2Service = ({
  cursor,
  pageSize,
  sorting,
  filters,
  consistency = 'Eventual',
}) =>
  axiosRequestPOST('/api/status/elements', {
    cursor,
    pageSize,
    sorting,
    filters,
    consistency,
  });

export const getElementStatusV2UserFiltersService = () =>
  axiosRequestGET('/api/status/filters');

export const getElementStatusV2FiltersResultCountService = () =>
  axiosRequestGET(`/api/status/filters/${elementStatusFilterType}/result-count`);

export const createElementStatusV2FilterService = (filter) =>
  axiosRequestPOST(`/api/status/filters/${elementStatusFilterType}`, filter);

export const updateElementStatusV2FilterService = ({ id, filter }) =>
  axiosRequestPUT(`/api/status/filters/${elementStatusFilterType}/${id}`, filter);

export const deleteElementStatusV2FilterService = (id) =>
  axiosRequestDELETE(`/api/status/filters/${elementStatusFilterType}/${id}`);

export const setElementStatusV2DefaultFilterService = (id) =>
  axiosRequestPUT(`/api/status/filters/${elementStatusFilterType}/default`, {
    id: id ?? EMPTY_ID,
  });
